import { isNil } from 'lodash'

import { AuctionMemberGroupEntity } from '@eastcoal/api/trade/interface'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

export const limitMembersValidator: SchemaItem['x-validator'] = {
  validator(value: {
    limitMember: boolean
    memberGroups?: AuctionMemberGroupEntity[]
  }) {
    if (!value.limitMember) {
      return null
    }

    if (isNil(value.memberGroups) || !value.memberGroups.length) {
      return '限定客户组不能为空'
    }

    return null
  }
}
